import {Injectable} from "@angular/core";
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {catchError, Observable, throwError} from "rxjs";
import {MatDialog} from "@angular/material/dialog";
import {InformationDialog} from "../_shared/dialog/information.dialog";
import {JwtHelperService} from "@auth0/angular-jwt";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private dialog: MatDialog,
        private jwtHelper: JwtHelperService,
    ) {
    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                const ignoredStatusCodes = [401];

                if (ignoredStatusCodes.includes(error.status)) {
                    return throwError(() => error); // Simply rethrow the error without modification
                }

                if(this.jwtHelper.isTokenExpired()) {
                    localStorage.clear();
                }

                console.log(req, error);

                if(error.status != 0) {
                    this.dialog.open(InformationDialog, {
                        data: {
                            title: 'Error',
                            message: error.error.description == '' || !error.error.description ? 'Unknown error, if the problem persists please report to us' : error.error.description
                        }
                    });
                }



                return throwError(() => new Error(error.error.description == '' || !error.error.description ? 'Unknown error, if the problem persists please report to us' : error.error.description));
            })
        );
    }
}
